import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import TablePage from './TablePage.js'
import EditPage from './EditPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ABIEntrySummaryTranslationProvider from "../contexts/ABIEntrySummaryTranslationContext";

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
            <TablePage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
          <EditPage showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}


export {
  WrappedEditPage as EditPage,
  WrappedTablePage as TablePage
}
